<template>
    <div id="d-group">
        <div class="grid pb-0" v-if="!mobiTablet">
            <div class="grid-title d-flex">
                <h4>{{ $t("BOOKING_LIST_GROUP") }}</h4>
                <div class="mr-3 d-flex align-items-end ml-auto">
                    <v-btn outlined @click="exportBooking" class="export-excel">
                        <v-icon size="20" left>
                            save_alt
                        </v-icon>
                        {{ $t("_BOOKING.EXPORT") }}
                    </v-btn>
                </div>
            </div>
            <div class="grid-body border-top-unset list-booking-group">
                <!-- start -->
                <div class="p-3">
                    <div class="search-box">
                        <v-btn @click="searchByCode()" outlined class="search-icon-left">
                        <svg focusable="false" height="24px" viewBox="0 0 24 24" width="24px" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20.49,19l-5.73-5.73C15.53,12.2,16,10.91,16,9.5C16,5.91,13.09,3,9.5,3S3,5.91,3,9.5C3,13.09,5.91,16,9.5,16 c1.41,0,2.7-0.47,3.77-1.24L19,20.49L20.49,19z M5,9.5C5,7.01,7.01,5,9.5,5S14,7.01,14,9.5S11.99,14,9.5,14S5,11.99,5,9.5z"></path><path d="M0,0h24v24H0V0z" fill="none"></path>
                        </svg>
                        </v-btn>
                        <input v-model="bookingCodeSearch" @keyup.enter="searchByCode()" type="text" :placeholder="$t('_BOOKING.ENTER_BOOKING_GROUP_CODE')" />
                        <v-btn outlined @click="openPopup()" class="search-icon-right">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"></path></svg>
                        </v-btn>
                    </div>
                </div>
                <div class="overlay-search" @click="openPopup()" v-if="isShowPopup"></div>
                <div class="popup-search p-3" v-if="isShowPopup">
                    <b-row>
                        <b-col  md="6" class="py-0 pr-0">
                            <div>
                                <label>
                                    {{
                                        $t("_BOOKING.SEARCH_CONDITION")
                                    }}
                                </label>
                                <v-select outlined dense item-text="text" item-value="value" :items="listSearchCondition"
                                    v-model="selectedSearchCondition" />
                            </div>
                        </b-col>
                        <b-col md="6" v-if="selectedSearchCondition === 'BOOKING_GROUP_NAME' ||
                            selectedSearchCondition === 'BOOKING_GROUP_CODE' ||
                            selectedSearchCondition === 'GROUP_PROFILE_NAME' ||
                            selectedSearchCondition === 'GROUP_PROFILE_CODE'"
                            class="py-0"
                        >
                            <div>
                                <label class="lable-search">{{
                                    $t("ENTER_TEXT", {
                                        text: listSearchCondition.find(e => e.value ===
                                            selectedSearchCondition).text
                                    })
                                }}</label>
                                <v-text-field v-model="paging.code" dense outlined></v-text-field>
                            </div>
                        </b-col>
                        <b-col md="6" v-if="
                            selectedSearchCondition === null ||
                            selectedSearchCondition === 'BOOKING_GROUP_CREATE_DATE' ||
                            selectedSearchCondition === 'BOOKING_GROUP_END_DATE' ||
                            selectedSearchCondition === 'BOOKING_GROUP_START_DATE'"
                            class="py-0"
                        >
                            <div>
                                <label>{{
                                    $t("_BOOKING.SEARCH_DATE")
                                }}</label>
                                <div class="d-flex justify-content-between">
                                    <date-picker :confirm-text="$t('CONFIRM')" :clearable="false" :type="selectedSearchCondition === 'BOOKING_GROUP_CREATE_DATE' ? 'datetime' : 'date'"
                                    :format="selectedSearchCondition === 'BOOKING_GROUP_CREATE_DATE' ? 'DD/MM/YYYY HH:mm:ss' : 'DD/MM/YYYY'"
                                        :popup-class="'popup-calendar-desktop-detailhotel'" v-model="dateRange"
                                        :lang="languageDate" :editable="false" :shortcuts=[] range
                                        placeholder="Select date range">
                                    </date-picker>
                                </div>
                            </div>
                        </b-col>
                        <b-col md="6" v-if="selectedSearchCondition === 'STAY_DATE'" class="py-0">
                            <div>
                                <label>{{
                                $t("_BOOKING.SEARCH_BY.STAYING_DATE")
                                }}</label>
                                <div class="d-flex justify-content-between">
                                <date-picker :confirm-text="$t('CONFIRM')" :clearable="false"
                                    :popup-class="'popup-calendar-desktop-detailhotel'" v-model="stayDate" :lang="languageDate"
                                    :format="'DD/MM/YYYY'" :editable="false" :shortcuts=[] :range="false" placeholder="Select date">
                                </date-picker>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div>
                                <label>{{
                                    $t("_BOOKING.BOOKING_STATUS")
                                }}</label>
                                <v-autocomplete
                                    dense
                                    outlined
                                    item-text="text"
                                    item-value="value"
                                    :items="listStatus"
                                    v-model="paging.status"
                                    chips
                                    multiple
                                >
                                    <template v-slot:prepend-item>
                                    <p class="mx-3 mt-1"> <a class="text-primary"
                                        @click="paging.status = listStatus.map(e => e.value)">{{ $t('SELECT_ALL') }}</a> | <a
                                        class="text-primary" @click="paging.status = []">{{ $t('UN_SELECT_ALL') }}</a>
                                    </p>
                                    </template>

                                    <template v-slot:selection="{ item, index }">
                                    <v-chip color="primary" v-if="index === 0" v-bind="item.attrs" :input-value="item.selected" close
                                        @click:close="remove(index, paging.status)" @click="item.select">
                                        <p class="mb-0 text-truncate" style="max-width: 150px">{{ item.text }}</p>
                                    </v-chip>
                                    <span v-if="index === 1" class="grey--text caption">(+{{ paging.status.length - 1 }})</span>
                                    </template>
                                    <template slot="no-data">
                                    <div class="no-data">{{ $t("NO_DATA") }}</div>
                                    </template>
                                </v-autocomplete>
                            </div>
                        </b-col>
                    </b-row>
                    <!-- End coding -->
                    <div class="d-flex justify-end align-items-end flex-wrap py-0 mb-2">
                        <div class="mr-3 reset">
                            <v-btn class="pl-5 pr-5" @click="reset()">
                                <v-icon size="20" left>
                                    mdi-refresh
                                </v-icon>
                                {{ $t("_BOOKING.RESET") }}
                            </v-btn>
                        </div>
                        <div class="mr-3">
                            <v-btn color="primary" class="pl-5 pr-5" @click="getAll(true)">
                                <v-icon size="20" left>
                                    search
                                </v-icon>
                                {{ $t("_BOOKING.SEARCH") }}
                            </v-btn>
                        </div>
                    </div>
                </div>
                <!-- end -->

                <!-- button scroll -->
                <div ref="containerCondition" class="container-condition py-4 pt-0">
                    <div class="d-flex align-items-center">
                    <button
                        v-if="isShowArrow"
                        class="left round"
                        @click="scrollLeft"
                        >
                        <v-icon>mdi-chevron-left</v-icon>
                    </button>            
                    <div ref="scrollContainer" class="overflow-auto scroll-container">
                        <div v-if="bookingGroupName" class="d-inline-flex gap-3">
                            <label :title="bookingGroupName">
                                <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionSearch === 'BOOKING_GROUP_NAME' && bookingGroupName && !isClear ? 'active-condition' : ''">
                                {{  $t("_BOOKING_GROUP.BOOKING_GROUP_NAME") }} {{ bookingGroupName && !isClear ? ': ' + bookingGroupName : '' }}
                            </div>		
                            </label>
                        </div>

                        <div v-if="groupProfileName" class="d-inline-flex gap-3">
                            <label :title="groupProfileName">
                                <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionSearch === 'GROUP_PROFILE_NAME' && groupProfileName && !isClear ? 'active-condition' : ''">
                                    {{  $t("_BOOKING_GROUP.GROUP_PROFILE_NAME") }} {{ groupProfileName && !isClear ? ': ' + groupProfileName : '' }}
                            </div>		
                            </label>
                        </div>

                        <div v-if="groupProfileCode" class="d-inline-flex gap-3">
                            <label :title="groupProfileCode">
                                <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionSearch === 'GROUP_PROFILE_CODE' && groupProfileCode && !isClear ? 'active-condition' : ''">
                                    {{  $t("_BOOKING_GROUP.GROUP_PROFILE_CODE") }} {{ groupProfileCode && !isClear ? ': ' + groupProfileCode : '' }}
                            </div>		
                            </label>
                        </div>
                        <div v-if="conditionSearch === 'BOOKING_GROUP_START_DATE'" class="d-inline-flex gap-3">
                            <label class="" :title="conditionSearch === 'BOOKING_GROUP_START_DATE' && conditionDateRange[0] ? formatDate(conditionSearch, conditionDateRange) : ''">
                            <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionSearch === 'BOOKING_GROUP_START_DATE' && conditionDateRange[0] && !isClear ? 'active-condition' : ''">
                            {{ $t("_BOOKING_GROUP.BOOKING_GROUP_START_DATE") }} {{ conditionSearch === 'BOOKING_GROUP_START_DATE' && conditionDateRange[0] && !isClear ? ': '+ formatDate(conditionSearch, conditionDateRange) : ''  }}
                            </div>
                        </label>
                        </div>

                        <div v-if="conditionSearch === 'BOOKING_GROUP_END_DATE'" class="d-inline-flex gap-3">
                            <label class="" :title="conditionSearch === 'BOOKING_GROUP_END_DATE' && conditionDateRange[0] ? formatDate(conditionSearch, conditionDateRange) : ''">
                            <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionSearch === 'BOOKING_GROUP_END_DATE' && conditionDateRange[0] && !isClear ? 'active-condition' : ''">
                            {{ $t("_BOOKING_GROUP.BOOKING_GROUP_END_DATE") }} {{ conditionSearch === 'BOOKING_GROUP_END_DATE' && conditionDateRange[0] && !isClear ? ': '+ formatDate(conditionSearch, conditionDateRange) : ''  }}
                            </div>
                        </label>
                        </div>

                        <div v-if="conditionSearch === 'BOOKING_GROUP_CREATE_DATE'" class="d-inline-flex gap-3">
                            <label class="" :title="conditionSearch === 'BOOKING_GROUP_CREATE_DATE' && conditionDateRange[0] ? formatDate(conditionSearch, conditionDateRange) : ''">
                            <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionSearch === 'BOOKING_GROUP_CREATE_DATE' && conditionDateRange[0] && !isClear ? 'active-condition' : ''">
                            {{ $t("_BOOKING_GROUP.BOOKING_GROUP_CREATE_DATE") }} {{ conditionSearch === 'BOOKING_GROUP_CREATE_DATE' && conditionDateRange[0] && !isClear ? ': '+ formatDate(conditionSearch, conditionDateRange) : ''  }}
                            </div>
                        </label>
                        </div>

                        <div v-if="conditionSearch === 'STAY_DATE'" class="d-inline-flex gap-3">
                            <label class="" :title="conditionStayDate ? formatDate(conditionSearch, conditionStayDate) : ''">
                            <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionSearch === 'STAY_DATE' && conditionStayDate && !isClear? 'active-condition' : ''">
                            {{ $t("_BOOKING.SEARCH_BY.STAYING_DATE") }} {{ conditionSearch === 'STAY_DATE' && conditionStayDate && !isClear ? ': '+ formatDate(conditionSearch, conditionStayDate) : ''  }}
                            </div>
                        </label>
                        </div>

                        <div class="d-inline-flex gap-3">
                            <label :title="listNameBKStatus && listNameBKStatus.join('\n')">
                            <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="listNameBKStatus.length > 0 && !isClear ? 'active-condition' : ''">
                                {{ $t("_BOOKING_TRANSACTION.BOOKING_STATUS") }} {{ listNameBKStatus.length > 0 && !isClear ? (listNameBKStatus.length > 1 ? ': ' + listNameBKStatus[0]+'...' : ': ' + listNameBKStatus[0]) : ''  }}
                            </div>		
                            </label>
                        </div>
                    </div>
                    <button
                        v-if="isShowArrow"
                        class="right round"
                        @click="scrollRight"
                        >
                        <v-icon>mdi-chevron-right</v-icon>
                    </button>
                    </div>
                </div>
                <!-- button scroll -->

                <v-progress-linear class="custom-progress" color="warning" indeterminate rounded height="3" v-if="isLoading"></v-progress-linear>

                <v-simple-table v-if="!isLoading" class="table-booking">
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th v-for="header in headers" :class="header.class">
                                    {{ header.text }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="dataTable.length > 0">
                                <tr v-for="(item, i) in dataTable">
                                    <td class="text-center vertical-middle">{{ paging.offset + i + 1 }}</td>
                                    <td class="vertical-middle font-weight-bold">
                                        <a class="app-link text-decoration-none" href="javascript:;"
                                            @click="goToBookingDetail(item.id)">
                                            {{
                                                item.bookingGroupCode
                                            }}
                                        </a>
                                    </td>
                                    <td class="vertical-middle">{{ item.nameVi }}</td>
                                    <td class="vertical-middle">{{ item.groupProfile ? item.groupProfile.groupProfileCode :
                                        item.bookingGroupProfile.bookingGroupProfileCode }}</td>
                                    <td class="vertical-middle">{{ item.groupProfile ? item.groupProfile.nameVi :
                                        item.bookingGroupProfile.nameVi }}
                                    </td>
                                    <td class="text-center vertical-middle">
                                        {{
                                            listStatus.find(x => x.value == item.bookingGroupStatus).text
                                        }}
                                    </td>
                                    <td class="text-right vertical-middle">
                                        <template v-if="systemLang == 'vi'">
                                            {{
                                                _formatDateTime(item.arrival, "YYYY-MM-DD", "DD/MM/YYYY")
                                            }}
                                        </template>
                                        <template v-else>
                                            {{
                                                _formatDateTime(item.arrival, "YYYY-MM-DD", "YYYY/MM/DD")
                                            }}
                                        </template>
                                    </td>
                                    <td class="text-right vertical-middle">
                                        <template v-if="systemLang == 'vi'">
                                            {{
                                                _formatDateTime(item.departure, "YYYY-MM-DD", "DD/MM/YYYY")
                                            }}
                                        </template>
                                        <template v-else>
                                            {{
                                                _formatDateTime(item.departure, "YYYY-MM-DD", "YYYY/MM/DD")
                                            }}
                                        </template>
                                    </td>
                                    <td class="text-right vertical-middle">
                                        <template v-if="systemLang == 'vi'">
                                            {{
                                                _formatDateTime(item.createdDate, "YYYY-MM-DD", "DD/MM/YYYY HH:mm:ss")
                                            }}
                                        </template>
                                        <template v-else>
                                            {{
                                                _formatDateTime(item.createdDate, "YYYY-MM-DD", "YYYY/MM/DD HH:mm:ss")
                                            }}
                                        </template>
                                    </td>

                                </tr>
                            </template>
                            <template v-else>
                                <tr>
                                    <td colspan="9" class="text-center vertical-middle font-weight-bold font-italic"
                                        style="color:red">
                                        {{ $t('BOOKING_EMPTY') }}
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </template>
                </v-simple-table>
                <v-row
              class="mt-2 mx-3"
              align="center"
              justify="center"
            >
              <span class="grey--text">{{  $t('ITEMS_PER_PAGE') }}</span>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    dark
                    text
                    color="primary"
                    class="ml-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ paging.limit }}
                    <v-icon>mdi-chevron-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(number, index) in itemsPerPageArray"
                    :key="index"
                    @click="paging.limit = number; getAll(true)"
                  >
                    <v-list-item-title>{{ number }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-spacer></v-spacer>

              <paging v-if="paging && paging.total" :paging.sync="paging" @changePage="changePage" class="px-3">
                    <span slot="totalItems">{{ $t("TOTAL") }}: {{ $tc("_BOOKING.BOOKING", paging.total) }}</span>
                </paging>
            </v-row>
                
            </div>
        </div>
        <v-navigation-drawer
        v-model="showDetail"
        absolute
        temporary
        right
        :width="sideBarWidth"
        >
        <booking-detail 
        v-if="showDetail" 
        :code="code" 
        @close="()=> {showDetail = false}"
        @showChildDetail="()=> {sideBarWidth = 1200}"
        @closeChildDetail="()=> {sideBarWidth = 1000}"
        ></booking-detail>
        </v-navigation-drawer>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { service } from "@/_services/Group/group.service.js";
import moment from "moment";
import FileSaver from "file-saver";
import Paging from "@/components/Utils/Paging.vue";
import {
    _alert,
    _formatCurrency,
    _formatDateTimeUTCToLocal
} from "@/_helpers/function.js";
import BookingDetail from "./BookingDetail.vue";
export default {
    components: {
        "date-picker": DatePicker,
        paging: Paging,
        BookingDetail,
    },
    data() {
        return {
            dateRange: [],
            stayDate: null,
            systemLang: this.$i18n.locale,
            isLoading: false,
            selectedSearchCondition: 'BOOKING_GROUP_NAME',
            listSearchCondition: [
                {
                    value: "BOOKING_GROUP_NAME",
                    text: this.$t("_BOOKING_GROUP.BOOKING_GROUP_NAME")
                },
                {
                    value: "BOOKING_GROUP_CODE",
                    text: this.$t("_BOOKING_GROUP.BOOKING_GROUP_CODE")
                },
                {
                    value: "GROUP_PROFILE_NAME",
                    text: this.$t("_BOOKING_GROUP.GROUP_PROFILE_NAME")
                },
                {
                    value: "GROUP_PROFILE_CODE",
                    text: this.$t("_BOOKING_GROUP.GROUP_PROFILE_CODE")
                },
                {
                    value: "BOOKING_GROUP_START_DATE",
                    text: this.$t("_BOOKING_GROUP.BOOKING_GROUP_START_DATE")
                },
                {
                    value: "BOOKING_GROUP_END_DATE",
                    text: this.$t("_BOOKING_GROUP.BOOKING_GROUP_END_DATE")
                },
                {
                    value: "BOOKING_GROUP_CREATE_DATE",
                    text: this.$t("_BOOKING_GROUP.BOOKING_GROUP_CREATE_DATE")
                },
                {
                    value: "STAY_DATE",
                    text: this.$t("_BOOKING.SEARCH_BY.STAYING_DATE")
                }
            ],
            paging: {
                total: 0,
                limit: 15,
                offset: 0,
                searchBy: 'BOOKING_GROUP_NAME',
                code: null,
                from: null,
                to: null,
                status: [0, 1, 2, 3, 4, 5, 6, 7]
            },
            listStatus: [
                {
                    value: 0,
                    text: this.$t("_GROUP_STATUS.HOLD")
                },
                {
                    value: 1,
                    text: this.$t("_GROUP_STATUS.TENTATIVE")
                },
                {
                    value: 2,
                    text: this.$t("_GROUP_STATUS.CONFIRMED")
                },
                {
                    value: 3,
                    text: this.$t("_GROUP_STATUS.CANCELED")
                },
                {
                    value: 4,
                    text: this.$t("_GROUP_STATUS.NO_SHOW")
                },
                {
                    value: 5,
                    text: this.$t("_GROUP_STATUS.CHECKED_IN")
                },
                {
                    value: 6,
                    text: this.$t("_GROUP_STATUS.CHECKED_OUT")
                },
                {
                    value: 7,
                    text: this.$t("_GROUP_STATUS.CLOSE")
                },
            ],
            dataTable: [],
            isShowPopup: false,
            isScrollLeftDisabled: true,
            isScrollRightDisabled: false,
            conditionStayDate: null,
            bookingCodeSearch: '',
            isClear: false,
            bookingGroupName: '',
            bookingGroupCode: '',
            groupProfileName: '',
            groupProfileCode: '',
            listNameBKStatus: [],
            conditionDateRange: [],
            conditionSearch: 'BOOKING_GROUP_NAME',
            showDetail: false,
            code: null,
            currentRoute: this.$route.path,
            sideBarWidth: 1000,
            widthScroll: 0,
            widthContainer: 0,
            resizeObserver: null,
            isShowArrow: false
        }
    },
    watch: {
        showDetail() {
            if(this.showDetail == false) {
                history.pushState(null, '', `${this.currentRoute}`);
            }
        },
        dateRange() {
            this.paging.from = this.dateRange[0];
            this.paging.to = this.dateRange[1];
        },
        widthScroll() {
            if (this.widthScroll + 50 > this.widthContainer) {
                this.isShowArrow = true;
            } else {
                this.isShowArrow = false;
            }
        }
    },
    created() {
        let searchHistoryListBooking = sessionStorage.getItem('searchHistoryListBooking');
        if (searchHistoryListBooking) {
            searchHistoryListBooking = JSON.parse(searchHistoryListBooking);
            this.selectedSearchCondition = searchHistoryListBooking.selectedSearchCondition;
            this.dateRange = [new Date(searchHistoryListBooking.dateRange[0]), new Date(searchHistoryListBooking.dateRange[1])];
            this.stayDate = new Date(searchHistoryListBooking.stayDate);
            
            this.paging = searchHistoryListBooking.paging;
            this.paging.offset = 0;
        } else {
            this.dateRange = [new Date(moment().format('YYYY-MM-DD')),
            new Date(moment().add(1, 'day').format('YYYY-MM-DD'))
            ];
            this.stayDate = new Date(moment().format('YYYY-MM-DD'));
        }
        this.getAll();
    },
    mounted() {
        this.resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                if (entry.target === this.$refs.scrollContainer) {
                this.widthScroll = entry.contentRect.width;
                } else if (entry.target === this.$refs.containerCondition) {
                this.widthContainer = entry.contentRect.width;
                }
            }
        });
        this.resizeObserver.observe(this.$refs.scrollContainer);
        this.resizeObserver.observe(this.$refs.containerCondition);
    },
    beforeDestroy() {
        if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        }
    },
    methods: {
        _moment: moment,
        _formatDateTime(value, inputFormat, outputFormat) {
            if (!value) {
                return "";
            }
            return moment(value).format(outputFormat);
        },
        changePage(paging) {
            this.paging = paging;
            this.getAll();
        },
        reset() {
            this.selectedSearchCondition = 'BOOKING_GROUP_NAME';
            // const today = new Date();
            // today.setHours(0);
            // today.setMinutes(0);
            // today.setSeconds(0);
            // const day1 = new Date(moment().add(1, 'day'));
            // day1.setHours(0);
            // day1.setMinutes(0);
            // day1.setSeconds(0);
            // this.dateRange = [today,day1];
            this.paging.code = '';
            this.paging.status = this.listStatus.map(e => e.value);
        },
        // Get all booking
        getAll(isSearching) {
            this.isClear = false;
            this.conditionStayDate = this.stayDate;
            this.bookingCodeSearch = '';
            this.mapValuesBKStatus();
            this.conditionDateRange = this.deepCopyArrayWithDates(this.dateRange);
            this.conditionSearch = this.selectedSearchCondition;
            this.isShowPopup = false;
            this.paging.searchBy = this.selectedSearchCondition;
            this.isClear = false;
            if (this.selectedSearchCondition === 'BOOKING_GROUP_NAME') {
                this.bookingGroupName = this.paging.code;
                this.groupProfileName = '';
                this.groupProfileCode = '';
            }
            if (this.selectedSearchCondition === 'GROUP_PROFILE_NAME') {
                this.bookingGroupName = '';
                this.groupProfileName = this.paging.code;
                this.groupProfileCode = '';
            }
            if (this.selectedSearchCondition === 'GROUP_PROFILE_CODE') {
                this.bookingGroupName = ''
                this.groupProfileName = '';
                this.groupProfileCode = this.paging.code;
            }
            if (this.selectedSearchCondition === null 
            || this.selectedSearchCondition === 'BOOKING_GROUP_CREATE_DATE' 
            || this.selectedSearchCondition === 'BOOKING_GROUP_END_DATE' 
            || this.selectedSearchCondition === 'BOOKING_GROUP_START_DATE') {
                if (this.isSixMonthsOrLess(this.paging.from, this.paging.to) === 1) {
                _alert(null, this.$t("PLEASE_SELECT_DATE_LESS_6_MONTH"));
                return
                }
            }
            if (this.selectedSearchCondition === 'BOOKING_GROUP_CODE' && !this.paging.code) {
                this.paging.total = 0;
                this.dataTable = [];
                return
            }
            if (isSearching) this.paging.offset = 0;
            this.isLoading = true;
            const body = {
                limit: this.paging.limit,
                offset: this.paging.offset,
                searchBy: this.selectedSearchCondition,
                from: this.paging.from,
                to: this.paging.to,
                code: this.paging.code,
                status: this.paging.status,
                stayDate: moment(this.stayDate).format('YYYY-MM-DD')
            };
            service
                .getAllBooking(body)
                .then(res => {
                    if (res.responseCode === 0) {
                        this.paging.total = res.total;
                        this.dataTable = res.data;
                    } else {
                        _alert(res, this.$t(res.data), false);
                    }
                })
                .finally(() => (this.isLoading = false));
        },
        searchByCode() {
            this.listNameBKStatus = [];
            this.conditionDateRange = [];
            this.conditionStayDate = null;
            this.selectedSearchCondition = 'BOOKING_GROUP_CODE';
            if (this.selectedSearchCondition === 'BOOKING_GROUP_CODE' && !this.bookingCodeSearch) {
                this.paging.total = 0;
                this.dataTable = [];
                return
            }
            this.isClear = true;
            this.isLoading = true;
            const body = {
                limit: this.paging.limit,
                offset: this.paging.offset,
                searchBy: this.selectedSearchCondition,
                from: null,
                to: null,
                code: this.bookingCodeSearch.trim(),
                status: [],
                stayDate: null
            };
            service
                .getAllBooking(body)
                .then(res => {
                    if (res.responseCode === 0) {
                        this.paging.total = res.total;
                        this.dataTable = res.data;
                    } else {
                        _alert(res, this.$t(res.data), false);
                    }
                })
                .finally(() => (this.isLoading = false));
        },
        remove(index, array) {
            array.splice(index, 1);
            this.$forceUpdate();
        },
        goToBookingDetail(code) {
            this.code = code;
            let searchHistoryListBooking = {
                selectedSearchCondition: JSON.parse(JSON.stringify(this.selectedSearchCondition)),
                paging: JSON.parse(JSON.stringify(this.paging)),
                dateRange: JSON.parse(JSON.stringify(this.dateRange)),
                stayDate: JSON.parse(JSON.stringify(this.stayDate)),
            };
            sessionStorage.setItem('searchHistoryListBooking', JSON.stringify(searchHistoryListBooking));

            const routeInfo = this.$router.resolve({ 
            name: "bookingDetailGroup",
            params: { code: code } 
            });
            history.pushState(null, '', routeInfo.href);
            this.showDetail = true;
        },
        exportBooking() {
            const body = {
                limit: this.paging.limit,
                offset: this.paging.offset,
                searchBy: this.selectedSearchCondition,
                from: this.paging.from,
                to: this.paging.to,
                code: this.paging.code,
                status: this.paging.status,
                stayDate: moment(this.stayDate).format('YYYY-MM-DD')
            };
            service
                .exportBooking(body)
                .then(res => {
                    if (res.responseCode === 0) {
                        const url = res.data;
                        FileSaver.saveAs(url);
                    } else {
                        _alert(res, this.$t(res.data), false);
                    }
                })
                .finally(() => (this.isLoading = false));
        },
        openPopup() {
            this.isShowPopup = !this.isShowPopup;
        },
        scrollLeft() {
            const container = this.$refs.scrollContainer;
            container.scrollBy({
                left: -200,
                behavior: "smooth",
            });
        },
        scrollRight() {
            const container = this.$refs.scrollContainer;
            container.scrollBy({
                left: 200,
                behavior: "smooth",
            });
        },
        
        formatDate(condition, dateRage) {
            var dateStart = moment(dateRage[0], "YYYY-MM-DD");
            var dateEnd = moment(dateRage[1], "YYYY-MM-DD");
            if (condition === 'BOOKING_GROUP_CREATE_DATE') {
                return dateStart.format("DD/MM/YYYY HH:mm:ss") + ' ~ ' + dateEnd.format("DD/MM/YYYY HH:mm:ss");
            } else if (condition === 'STAY_DATE') {
                return moment(dateRage, "DD/MM/YYYY").format("DD/MM/YYYY");
            } else {
                return dateStart.format("DD/MM/YYYY")+ ' ~ ' + dateEnd.format("DD/MM/YYYY");
            }
        },
        mapValuesBKStatus() { 
            this.listNameBKStatus = this.paging.status.map(id => {
                const matchedItem = this.listStatus.find(item => item.value === id); 
                return matchedItem ? matchedItem.text : null; 
            }).filter(item => item !== null)
        },
    },
    computed: {
        headers() {
            return [
                {
                    text: this.$t("STT"),
                    class: "text-center"
                },
                {
                    text: this.$t("_BOOKING_GROUP.BOOKING_GROUP_CODE"),
                    value: "bookingGroupCode",
                },
                {
                    text: this.$t("_BOOKING_GROUP.BOOKING_GROUP_NAME"),
                    value: "bookingGroupCode",
                },
                {
                    text: this.$t("_BOOKING_GROUP.GROUP_PROFILE_CODE"),
                    value: "bookingGroupCode",
                },
                {
                    text: this.$t("_BOOKING_GROUP.GROUP_PROFILE_NAME"),
                    value: "nameVi",
                },
                {
                    text: this.$t("_BOOKING_GROUP.STATUS"),
                    class: "text-center",
                },
                {
                    text: this.$t("_BOOKING_GROUP.BOOKING_GROUP_START_DATE"),
                    class: "text-right",
                },
                {
                    text: this.$t("_BOOKING_GROUP.BOOKING_GROUP_END_DATE"),
                    class: "text-right",
                },
                {
                    text: this.$t("_BOOKING_GROUP.BOOKING_GROUP_CREATE_DATE"),
                    class: "text-right",
                },
            ];
        }
    },

}
</script>
<style lang="scss">
#d-group {
    .list-booking-group .mx-input-wrapper {
        top: 3px;
    }

    .mx-input {
        height: 37px !important;
        // border: 1px solid #dcdcdc !important;
    }
}
</style>